import React, { useState } from "react";
import Sidebar from "./Sidebar";
import Appbar from "./Appbar";
import { Footer } from "./Footer";

const LayoutWrapper = ({ children, hideSidebar = false }) => {

  return (
    <div className="flex flex-1 h-full w-full text-black">
      <div className="w-full h-full flex">
        <div className="w-full h-full flex flex-col overflow-hidden">
          <Appbar />
          <div
            className="flex flex-1 h-screen w-full text-black bg-white"
            style={{ overflow: "hidden" }}
          >
            <div className="flex-1 py-6 overflow-auto h-full flex flex-col">
              {children}
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default LayoutWrapper;
